export const HELP_CENTER_ARTICLES_PAGE_SIZE = 5;
